<template>
  <a-spin :spinning="spinning">
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="单据日期">
              <a-range-picker @change="dateChange" :defaultValue="[moment(queryParam.s_date, format), moment(queryParam.e_date, format)]"></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="供应商"
            >
              <a-input-search
                placeholder="请选择供应商"
                @change="supplierTextChange"
                @search="onSupplierSearch"
                @click="onSupplierSearch"
                v-model="supplierNames"
              ><a-button slot="enterButton">选择</a-button></a-input-search>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="商品"
            >
              <a-input-search
                placeholder="请选择商品"
                @change="goodsTextChange"
                @search="onGoodsSearch"
                @click="onGoodsSearch"
                v-model="goodsNames"
              ><a-button slot="enterButton">选择</a-button></a-input-search>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              label="商品类别"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol">
              <a-tree-select
                placeholder="请选择商品类别"
                treeDefaultExpandAll
                :treeData="categoryData"
                treeCheckable
                @change="onChange"
                :showCheckedStrategy="SHOW_ALL"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              label="单据编号"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol">
              <a-input placeholder="请输入单据号" v-model="queryParam.kw"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="仓库"
            >
              <a-input-search
                placeholder="请选择仓库"
                @change="storeTextChange"
                @search="onStoreSearch"
                @click="onStoreSearch"
                v-model="storeNames"
              ><a-button slot="enterButton">选择</a-button></a-input-search>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch" style="margin-right: 8px">查询</a-button>
              <a-button @click="exportExcel">导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!--// 表格 //-->
    <div v-if="!tableData"><a-divider>输入查询条件，点击查询吧</a-divider></div>
    <div v-if="tableData">
      <div class="table-wrapper">
        <div class="ant-table-wrapper">
          <div class="ant-spin-nested-loading">
            <div class="ant-spin-container">
              <div class="ant-table ant-table-scroll-position-left ant-table-default ant-table-bordered">
                <div class="ant-table-content">
                  <div class="ant-table-body">
                    <table>
                      <thead class="ant-table-thead">
                      <tr>
                        <th class="text-center"><div>采购日期</div></th>
                        <th class="text-center"><div>采购单据号</div></th>
                        <th class="text-center"><div>业务类别</div></th>
                        <th class="text-center"><div>供应商</div></th>
                        <th class="text-center"><div>商品名称</div></th>
                        <th class="text-center"><div>规格型号</div></th>
                        <th class="text-center"><div>单位</div></th>
                        <th class="text-center"><div>仓库</div></th>
                        <th class="text-center"><div>数量</div></th>
                        <th class="text-center"><div>单价</div></th>
                        <th class="text-center"><div>金额</div></th>
                        <th class="text-center"><div>备注</div></th>
                      </tr>
                      </thead>
                      <tbody class="ant-table-tbody">
                      <tr v-for="(item, index) in tableData.list" :key="index" class="ant-table-row">
                        <td class="text-center">{{ item.billDate }}</td>
                        <td class="text-center">{{ item.srcBillNo }}</td>
                        <td class="text-center">{{ item.billStatusName }}</td>
                        <td class="text-center">{{ item.supplier.name }}</td>
                        <td class="text-center">{{ item.goods.name }}</td>
                        <td class="text-center">{{ item.goods.type }}</td>
                        <td class="text-center">{{ item.unit.name }}</td>
                        <td class="text-center">{{ item.store.name }}</td>
                        <td class="text-center">{{ item.qty }}</td>
                        <td class="text-center">{{ item.price }}</td>
                        <td class="text-center">{{ item.amount }}</td>
                        <td class="text-center">{{ item.note }}</td>
                      </tr>
                      <tr class="ant-table-row">
                        <td class="text-left" colspan="8"><strong>合计</strong></td>
                        <td class="text-center"><strong>{{tableData.total.totalQty}}</strong></td>
                        <td class="text-center"></td>
                        <td class="text-center"><strong>{{tableData.total.toalQtyAmount}}</strong></td>
                        <td class="text-center"></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--// 表格 //-->
    <SupplierModal :visible="supplierModalVisible" @handleCancel="supplierModalCancel" @handleOk="supplierModalOk"></SupplierModal>
    <GoodsModal :visible="goodsModalVisible" @handleCancel="goodsModalCancel" @handleOk="goodsModalOk"></GoodsModal>
    <StoreModal :visible="storeModalVisible" @handleCancel="storeModalCancel" @handleOk="storeModalOk"></StoreModal>
  </a-card>
  </a-spin>
</template>
<script>
import moment from 'moment'
import SupplierModal from '@/components/Supplier/Modal'
import GoodsModal from '@/components/Goods/Modal'
import StoreModal from '@/components/Store/Modal'
import { purchaseReportEntries } from '@/api/bill'
import { getCategoryGoods } from '@/api/category'
import { TreeSelect } from 'ant-design-vue'
import { downloadExcel } from '@/utils/util'
import { excelPurchaseReportEntries } from '@/api/excel'
const SHOW_ALL = TreeSelect.SHOW_ALL
export default {
  components: {
    SupplierModal,
    GoodsModal,
    StoreModal
  },
  data () {
    return {
      SHOW_ALL,
      spinning: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      supplierModalVisible: false,
      goodsModalVisible: false,
      storeModalVisible: false,
      // 查询参数
      queryParam: {
        s_date: '',
        e_date: '',
        supplierIds: '',
        goodsIds: '',
        storeIds: '',
        kw: '',
        goodsCatIds: ''
      },

      supplierNames: '',
      goodsNames: '',
      storeNames: '',
      tableData: null,
      categoryData: null
    }
  },
  created () {
    this.queryParam.s_date = moment().subtract(7, 'days').format(this.format)
    this.queryParam.e_date = moment().format(this.format)
    this.loadCategory()
  },
  methods: {
    moment,
    supplierTextChange (e) {
      if (!e.data) {
        this.queryParam.supplierIds = ''
      }
    },
    goodsTextChange (e) {
      if (!e.data) {
        this.queryParam.goodsIds = ''
      }
    },
    storeTextChange (e) {
      if (!e.data) {
        this.queryParam.storeIds = ''
      }
    },
    supplierModalCancel () {
      this.supplierModalVisible = false
    },
    goodsModalCancel () {
      this.goodsModalVisible = false
    },
    storeModalCancel () {
      this.storeModalVisible = false
    },
    supplierModalOk (selectedRows) {
      this.supplierModalVisible = false
      if (selectedRows.length > 0) {
        const ids = []
        const names = []
        selectedRows.forEach(function (item) {
          ids.push(item.id)
          names.push(item.name)
        })
        this.queryParam.supplierIds = ids.join(',')
        this.supplierNames = names.join(',')
      }
    },
    goodsModalOk (selectedRows) {
      this.goodsModalVisible = false
      if (selectedRows.length > 0) {
        const ids = []
        const names = []
        selectedRows.forEach(function (item) {
          ids.push(item.id)
          names.push(item.name)
        })
        this.queryParam.goodsIds = ids.join(',')
        this.goodsNames = names.join(',')
      }
    },
    storeModalOk (selectedRows) {
      this.storeModalVisible = false
      if (selectedRows.length > 0) {
        const ids = []
        const names = []
        selectedRows.forEach(function (item) {
          ids.push(item.id)
          names.push(item.name)
        })
        this.queryParam.storeIds = ids.join(',')
        this.storeNames = names.join(',')
      }
    },
    onSupplierSearch () {
      this.supplierModalVisible = true
    },
    onGoodsSearch () {
      this.goodsModalVisible = true
    },
    onStoreSearch () {
      this.storeModalVisible = true
    },
    dateChange (date, dateString) {
      this.queryParam.s_date = dateString[0]
      this.queryParam.e_date = dateString[1]
    },
    tableSearch () {
      this.spinning = true
      purchaseReportEntries(this.queryParam)
        .then(res => {
          this.tableData = { ...res.result }
        }).catch(() => {})
        .finally(() => {
          this.spinning = false
        })
    },
    onChange (val) {
      this.queryParam.goodsCatIds = val.join(',')
    },
    loadCategory () {
      getCategoryGoods({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    exportExcel () {
      excelPurchaseReportEntries(this.queryParam).then(res => {
        downloadExcel(this.queryParam.s_date + '至' + this.queryParam.e_date + ' 采购明细表', res)
      })
    }
  },
  watch: {}
}
</script>
<style scoped>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
  >>> .ant-select-selection--multiple {
    height: 32px;
    overflow: hidden;
  }
</style>
